import api from '../../shared/api/client';
import { API_ROUTES } from '../../shared/api/routes';

export const userApi = {
  getUsers: (params) => api.get(API_ROUTES.users.base, { params }),
  exportUsers: (data) => api.post(API_ROUTES.users.export, data),
  getUserById: (id, params) => api.get(API_ROUTES.users.detail(id), { params }),
  sendCreateOtp: (data) => api.post(API_ROUTES.users.sendCreateOtp, data),
  sendEmailVerification: (id, data, params) =>
    api.post(API_ROUTES.users.emailVerification(id), data, { params }),
  createUser: (data) => api.post(API_ROUTES.users.base, data),
  updateUser: (id, data, params) => api.put(API_ROUTES.users.detail(id), data, { params }),
  deleteUser: (id) => api.delete(API_ROUTES.users.detail(id)),
  bulkImport: (data) => api.post(API_ROUTES.users.bulkImport, data),
};

export const vehicleApi = {
  getVehicles: (params) => api.get(API_ROUTES.vehicles.base, { params }),
  createVehicle: (userId, data) =>
    api.post(API_ROUTES.vehicles.base, {
      userId,
      societyId: data?.societyId,
      ...data,
    }),
  updateVehicleStatus: (id, data, params) => api.patch(API_ROUTES.vehicles.status(id), data, { params }),
  updateVehicle: (id, data, params) => api.put(API_ROUTES.vehicles.detail(id), data, { params }),
  deleteVehicle: (id, params) => api.delete(API_ROUTES.vehicles.detail(id), { params }),
  linkVehicleTagAccess: (data) => api.post(API_ROUTES.rfid.assign, data),
};

export const commonDataApi = {
  getAll: () => api.get(API_ROUTES.commonData.base),
  getByKey: (key) => api.get(API_ROUTES.commonData.detail(key)),
};
